export const nullFilter = (rows, columnId, filterValue) => {
  return rows.filter((row) => {
    const value = row.values[columnId[0]] ? String(row.values[columnId[0]]).toLowerCase() : '';
    if (
      (!value && filterValue === '--') ||
      !filterValue ||
      value.includes(filterValue ? filterValue.toLowerCase() : '')
    ) {
      return true;
    }
    return false;
  });
};

const removeDuplicates = (arr, key) => {
  return Array.from(new Set(arr.map((a) => a[key]))).map((id) => {
    return arr.find((a) => a[key] === id);
  });
};

export const mapListToDropdownList = (
  list,
  {keys, values, texts},
  allOption = false,
  separator = '-'
) => {
  if (list) {
    const listDropdown = [
      {
        'key': '',
        'value': '',
        'text': 'TODOS',
      },
    ];

    const listData = list.map((item) => {
      const itemKey = keys.map((key) => item[key]).join(separator);
      const itemValues = values.map((key) => item[key]).join(separator);
      const itemTexts = texts.map((key) => item[key]).join(separator);
      return {
        'key': itemKey,
        'value': itemValues,
        'text': itemTexts || '(Sin nombre)',
      };
    });
    const listWithoutDuplicates = removeDuplicates(listData, 'key');

    if (allOption) {
      return listDropdown.concat(listWithoutDuplicates);
    }
    return listWithoutDuplicates;
  }
  return [];
};
